import { ASSIGNED_DIFFICULTIES } from '@all-for-one/shared-types'
import styles from 'css/components/tables/difficulty-pills.module.css'
import React from 'react'

interface DifficultyPillsProps {
    currentDifficulty: string
    handleDifficultyChange: (difficulty: string) => void
    includeAll?: boolean
    availableDifficulties?: string[]
}

export const DifficultyPills: React.FC<DifficultyPillsProps> = ({ currentDifficulty, handleDifficultyChange, includeAll = true, availableDifficulties }) => {
	return (<div className={styles['difficulty-row']}>
			{includeAll && (
				<div
					className={`${styles['difficulty-pill']} ${currentDifficulty === 'All' ? styles.active : ''}`}
					onClick={() => handleDifficultyChange('All')}
				>
					All
				</div>
			)}

		{Object.values(ASSIGNED_DIFFICULTIES).map((difficulty: string) => {
			const hasData = !availableDifficulties || availableDifficulties.includes(difficulty)
			return (
				<div
					key={difficulty}
					className={`${styles['difficulty-pill']} ${hasData && currentDifficulty === difficulty ? styles.active : ''} ${!hasData ? styles.disabled : ''}`}
					onClick={hasData ? () => handleDifficultyChange(difficulty) : undefined}
				>
					{difficulty}
					{!hasData && <span className={styles['no-grades']}>no grades</span>}
				</div>
			)
		})}
	</div>)
}